export const langs = ['en', 'de', 'ro', 'es'] as const
export type TLang = (typeof langs)[number]

export const normalizeBrowserLang = (lang: string): TLang => {
    const base = (lang ?? 'en').split('-')[0].toLowerCase()
    return langs.includes(base as TLang) ? (base as TLang) : 'en'
}

export const languageСheck = (lang: TLang): TLang =>
    langs.includes(lang) ? lang : 'en'
